import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-volume",
  "use": "icon-volume-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-volume\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M9.93,14.84H7.17a.71.71,0,0,1-.71-.71V9.87a.71.71,0,0,1,.71-.71H9.93L13.7,6.08a.36.36,0,0,1,.5,0,.36.36,0,0,1,.08.23V17.64a.36.36,0,0,1-.36.36.35.35,0,0,1-.22-.08L9.94,14.84Zm7.09.42-1-1a2.84,2.84,0,0,0-.23-4.66l1-1A4.25,4.25,0,0,1,17,15.26Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol